import React from 'react';

import Box from '@mui/material/Box';

import Breadcrumbs from './Inside/Breadcrumbs';
import Content from './Inside/Content';
import SideNavbar from './Inside/SideNavbar';

// the layout that all inner pages are expected to use
const InsideLayout = ({ children, breadcrumbs = true, contentPadding }) => (
  <Box sx={{ display: 'flex' }}>
    <SideNavbar />
    <Content contentPadding={contentPadding}>
      {breadcrumbs && <Breadcrumbs />}
      {children}
    </Content>
  </Box>
);

export default InsideLayout;
